export default {
  "navigation.home": "home",
  "navigation.about": "about",
  "navigation.skills": "skills",
  "navigation.portfolio": "my work",
  "navigation.contact": "contact",
};
